import { Banknote, Clock, Building2, Users } from "lucide-react";

const fmtTL = (n) => {
  if (n == null) return "—";
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(".", ",")}M TL`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}K TL`;
  return `${n} TL`;
};

export const CostCompareCard = ({ data, candidateName }) => {
  if (!data) return null;
  const ext = { cost: data.external_hire_cost_tl, months: data.external_hire_months };
  const intMonths = data.internal_fastest_months;
  const intName = candidateName || data.internal_candidate_name;
  const savings = ext.cost && intMonths ? Math.round(ext.cost * 0.4) : null; // illustrative

  return (
    <div className="card-surface p-5" data-testid="cost-compare-card">
      <div className="flex items-center gap-2 mb-4">
        <Banknote className="w-4 h-4 text-amber-600" />
        <div className="label-eyebrow">Karar Anı: Dış Alım mı, İç Yetiştirme mi?</div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {/* External hire */}
        <div className="rounded-xl border border-rose-200 bg-rose-50/60 p-4">
          <div className="flex items-center gap-2 mb-2">
            <Building2 className="w-3.5 h-3.5 text-rose-700" />
            <span className="text-xs font-semibold text-rose-700 uppercase tracking-wider">Dış Alım</span>
          </div>
          <div className="font-display text-4xl font-semibold text-slate-900 mb-0.5">{fmtTL(ext.cost)}</div>
          <div className="text-xs text-slate-600 flex items-center gap-1">
            <Clock className="w-3 h-3" /> ~{ext.months} ay süreç
          </div>
          <div className="mt-2 text-[0.7rem] text-rose-700/90 leading-snug">
            Headhunter + onboarding · Kültürel uyum riski
          </div>
        </div>

        {/* Internal training */}
        <div className="rounded-xl border border-emerald-200 bg-emerald-50/60 p-4">
          <div className="flex items-center gap-2 mb-2">
            <Users className="w-3.5 h-3.5 text-emerald-700" />
            <span className="text-xs font-semibold text-emerald-700 uppercase tracking-wider">İç Yetiştirme</span>
          </div>
          <div className="font-display text-4xl font-semibold text-slate-900 mb-0.5">~{intMonths} ay</div>
          <div className="text-xs text-slate-600">{intName ? `Birincil aday: ${intName}` : "Aday bekleniyor"}</div>
          <div className="mt-2 text-[0.7rem] text-emerald-700/90 leading-snug">
            Kültürel süreklilik · Hedefli mentorluk
          </div>
        </div>
      </div>

      {savings && (
        <div className="mt-3 text-center text-xs text-slate-600">
          Tahmini tasarruf: <span className="text-emerald-700 font-semibold">~{fmtTL(savings)}</span> + kurumsal hafıza
        </div>
      )}
    </div>
  );
};

export default CostCompareCard;
